module.exports = __webpack_public_path__ + "static/media/marketing.e1b5e1c8.png";